import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class GroupChatsResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/group_chats' as const;

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}
